// Testimonials: staggered fade-in + slide-up as cards enter the viewport.
document.addEventListener( 'DOMContentLoaded', () => {
	const sections = Array.from( document.querySelectorAll( '.testimonials-block' ) );
	if ( ! sections.length ) return;

	const EASING  = 'cubic-bezier(0.22, 1, 0.36, 1)';
	const DURATION = 0.65;
	const STAGGER  = 0.12;
	const OFFSET   = '32px';

	sections.forEach( ( section ) => {
		const header = section.querySelector( '.text-center' );
		const cards  = Array.from( section.querySelectorAll( '.testimonial-card' ) );

		// Set initial states
		if ( header ) {
			header.style.opacity   = '0';
			header.style.transform = `translateY( ${ OFFSET } )`;
			header.style.transition = `opacity ${ DURATION }s ${ EASING }, transform ${ DURATION }s ${ EASING }`;
		}

		cards.forEach( ( card, i ) => {
			card.style.opacity    = '0';
			card.style.transform  = `translateY( ${ OFFSET } )`;
			card.style.transition = `opacity ${ DURATION }s ${ EASING } ${ ( i * STAGGER ) + 0.2 }s, transform ${ DURATION }s ${ EASING } ${ ( i * STAGGER ) + 0.2 }s`;
		} );

		if ( header ) {
			const headerObserver = new IntersectionObserver(
				( entries, obs ) => {
					entries.forEach( ( entry ) => {
						if ( entry.isIntersecting ) {
							header.style.opacity   = '1';
							header.style.transform = 'translateY(0)';
							obs.unobserve( entry.target );
						}
					} );
				},
				{ threshold: 0.30 }
			);
			headerObserver.observe( header );
		}

		cards.forEach( ( card ) => {
			const cardObserver = new IntersectionObserver(
				( entries, obs ) => {
					entries.forEach( ( entry ) => {
						if ( entry.isIntersecting ) {
							card.style.opacity   = '1';
							card.style.transform = 'translateY(0)';
							obs.unobserve( entry.target );
						}
					} );
				},
				{ threshold: 0.20 }
			);
			cardObserver.observe( card );
		} );
	} );
} );
